(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const bind=root=>root.querySelectorAll('.cv-header__mobile').forEach(menu=>{
  if(menu.dataset.drawerBound)return;menu.dataset.drawerBound='true';
  const panel=menu.querySelector('.cv-menu-panel'),trigger=menu.querySelector('summary');
  const close=()=>{menu.open=false;trigger.focus()};
  menu.querySelectorAll('[data-cv-menu-close]').forEach(button=>button.addEventListener('click',close));
  menu.addEventListener('toggle',()=>{trigger.setAttribute('aria-expanded',String(menu.open));if(menu.open)panel.querySelector('button').focus()});
  menu.addEventListener('keydown',event=>{
   if(!menu.open)return;
   if(event.key==='Escape'){event.preventDefault();const active=panel.querySelector('[data-picker-toggle][aria-expanded="true"]');if(active){active.setAttribute('aria-expanded','false');panel.querySelector('#'+active.getAttribute('aria-controls')).hidden=true;active.focus()}else close()}
   if(event.key==='Tab'){
    const items=[...panel.querySelectorAll('a[href],button,select')].filter(el=>!el.disabled&&el.getClientRects().length);
    const first=items[0],last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
   }
  });
  const collapsePickers=()=>panel.querySelectorAll('[data-picker-toggle]').forEach(button=>{button.setAttribute('aria-expanded','false');panel.querySelector('#'+button.getAttribute('aria-controls')).hidden=true});
  panel.querySelectorAll('[data-picker-toggle]').forEach(button=>button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')==='true';collapsePickers();if(!expanded){button.setAttribute('aria-expanded','true');panel.querySelector('#'+button.getAttribute('aria-controls')).hidden=false}}));
  panel.querySelectorAll('[data-locale-value]').forEach(button=>button.addEventListener('click',()=>{const form=button.closest('form');form.elements[button.dataset.localeName].value=button.dataset.localeValue;form.requestSubmit()}));
  panel.addEventListener('click',event=>{if(!event.target.closest('.cv-menu-picker'))collapsePickers()});
  menu.querySelectorAll('.cv-menu-links a').forEach(link=>link.addEventListener('click',()=>{menu.open=false}));
 });
 bind(document);document.addEventListener('shopify:section:load',event=>bind(event.target));
})();

(()=>{
 document.addEventListener('pointerdown',event=>document.querySelectorAll('[data-desktop-disclosure][open]').forEach(details=>{if(!details.contains(event.target))details.open=false}));
 document.addEventListener('keydown',event=>{const details=event.target.closest('[data-desktop-disclosure]');if(!details)return;if(event.key==='Escape'){event.preventDefault();details.open=false;details.querySelector('summary').focus()}if(event.target===details.querySelector('summary')&&event.key==='ArrowDown'){event.preventDefault();details.open=true;details.querySelector('a,button')?.focus()}});
 document.addEventListener('focusout',event=>{const details=event.target.closest('[data-desktop-disclosure]');if(details)queueMicrotask(()=>{if(!details.contains(document.activeElement))details.open=false})});
 document.addEventListener('click',event=>{const button=event.target.closest('[data-desktop-locale]');if(!button)return;button.form.elements[button.dataset.desktopLocale].value=button.dataset.localeValue});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-bag-step]');if(!button)return;const input=button.closest('.cv-bag-stepper').querySelector('input');const minimum=Number(input.min||1);const step=Number(input.step||1);const next=Number(input.value)+Number(button.dataset.bagStep)*step;if(next<minimum||(input.max&&next>Number(input.max)))return;input.value=next;input.dispatchEvent(new Event('change',{bubbles:true}));});
document.addEventListener('change',event=>{if(!event.target.matches('[data-bag-quantity]'))return;const input=event.target;if(!input.checkValidity()){input.reportValidity();return}input.form.requestSubmit(input.form.querySelector('[data-bag-update]'));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-haven"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("change", (event) => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches("[data-option]")) return;
  const section = event.target.closest("[data-product-section]");
  const label = section?.querySelector('[data-option-selected="' + event.target.dataset.option + '"]');
  if (label) label.textContent = event.target.value;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-meridian"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("change", (event) => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches("[data-option]")) return;
  const section = event.target.closest("[data-product-section]");
  const label = section?.querySelector('[data-option-selected="' + event.target.dataset.option + '"]');
  if (label) label.textContent = event.target.value;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-northbound-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("change", (event) => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches("[data-option]")) return;
  const section = event.target.closest("[data-product-section]");
  const label = section?.querySelector('[data-option-selected="' + event.target.dataset.option + '"]');
  if (label) label.textContent = event.target.value;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-snowy-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("change", (event) => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches("[data-option]")) return;
  const section = event.target.closest("[data-product-section]");
  const label = section?.querySelector('[data-option-selected="' + event.target.dataset.option + '"]');
  if (label) label.textContent = event.target.value;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("change", (event) => {
  if (!(event.target instanceof HTMLInputElement) || !event.target.matches("[data-option]")) return;
  const section = event.target.closest("[data-product-section]");
  const label = section?.querySelector('[data-option-selected="' + event.target.dataset.option + '"]');
  if (label) label.textContent = event.target.value;
});

  } catch(e) { console.error(e); }
})();
})();
